import {DomainError} from '@s-ui/domain'

export class ComparatorAdAdsError extends DomainError {
  #cause
  #code
  #message

  static GENERIC_ERROR_CODE = 'comparator_ad_ads_error'
  static INVALID_AD_ERROR_CODE = 'invalid_comparator_ad_ads_error'

  constructor({cause, code, message}) {
    super({cause, code, message})
    this.#cause = cause
    this.#code = code
    this.#message = message
  }

  static create({code, message, cause}) {
    return new ComparatorAdAdsError({code, message, cause})
  }

  static createGenericError({cause}) {
    return ComparatorAdAdsError.create({
      code: ComparatorAdAdsError.GENERIC_ERROR_CODE,
      cause
    })
  }

  static createInvalidAdError() {
    return ComparatorAdAdsError.create({
      code: ComparatorAdAdsError.INVALID_AD_ERROR_CODE,
      message: 'Invalid ad'
    })
  }

  isInvalidAdError() {
    return this.#code === ComparatorAdAdsError.INVALID_AD_ERROR_CODE
  }

  get value() {
    return {
      code: this.#code,
      message: this.message,
      cause: this.cause
    }
  }

  toJSON() {
    return {
      code: this.#code,
      message: this.#message,
      cause: this.#cause
    }
  }
}
